import React from 'react';
import styled from '@emotion/styled';
import BannerLeftImg from 'ui/images/top/many_banner_left.jpg';
import BannerRightImg from 'ui/images/top/many_banner_right.jpg';
import { mqMin } from 'utils/responsive';
import { Only } from 'ui/components/elements/Only/Only';
import { useNavigate } from 'react-router-dom';

const ForAgent = styled.div`
    text-align: center;
    padding: 0 0 62px 0;

    ${mqMin('NARROW')} {
        text-align: center;
        padding: 0 0 78px 0;
    }
`;

const TopOfferFooterP = styled.p`
    line-height: 1.8rem;
    letter-spacing: 0.1em;

    ${mqMin('NARROW')} {
        font-size: 1.1875rem; /*19px*/
        line-height: 1.8rem;
        letter-spacing: 0.1em;
        margin-bottom: 19px;
    }
`;

const ButtonBlue = styled.a`
    display: block;
    background-color: var(--blue);
    border-radius: 8px;
    border: solid 1px #fff;
    color: #fff;
    text-align: center;
    text-decoration: none;
    padding: 16px 20px;
    margin: 0 auto 0 auto;
    transition: all 0.3s;
    width: 250px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        color: var(--blue);
        background: none;
    }

    &:visited {
        color: #fff;
    }

    ${mqMin('NARROW')} {
        font-size: 0.9rem;
    }
`;

const BannerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 0 auto 3rem;
    justify-content: center;
    align-items: center;
    width: 88.37209302325581%;

    ${mqMin('SP')} {
        flex-direction: row;
    }
`;

const Banner = styled.img`
    width: 100%;
    height: auto;
    cursor: pointer;
    ${mqMin('SP')} {
        width: 48%;
    }

    &:hover {
        filter: brightness(0.9);
        transition: all 0.3s;
    }
`;

export const Offer: React.FC = () => {
    const navigate = useNavigate();

    const goToAgentPage = () => {
        navigate('/agent/');
    };
    const goToBuyerPage = () => {
        navigate('/buyer/');
    };
    const goToSellerPage = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const goToContactPage = () => {
        window.open('/contact/', '_blank');
    };
    return (
        <>
            <section className="fadein fadein_y">
                <ForAgent>
                    <BannerWrapper>
                        <Banner src={BannerLeftImg} alt="バナー" onClick={goToSellerPage} />
                        <Banner src={BannerRightImg} alt="バナー" onClick={goToBuyerPage} />
                    </BannerWrapper>
                    <ButtonBlue onClick={goToContactPage}>お問い合わせはこちら</ButtonBlue>
                    <TopOfferFooterP>
                        <br />
                        <br />
                        MAnyではM&A仲介会社も
                        <Only sp>
                            <br />
                        </Only>
                        募集しております。
                    </TopOfferFooterP>
                    <ButtonBlue onClick={goToAgentPage}>仲介会社登録はこちら</ButtonBlue>
                </ForAgent>
            </section>
        </>
    );
};
